<template>
  <div
    :key="`notification-${index}`"
    class="notification-row"
    @click="$emit('clickNotification', value)">
    <NotificationCardTitle
      :item="value"
      :mode="mode"
      @changeViewed="changeViewed"
      @close="$emit('close')"/>
    <div
      class="flex mb-4"
      :class="value.Author ? 'flex-between' : 'flex-right'">
      <NotificationCardAuthor
        class="notification-card-org"
        :class="mode"
        :mode="mode"
        :value="value"/>
      <TooltipedText
        class="ml-2 notification-type font-size-12"
        :class="{'modal': mode==='modal'}"
        :max-length="mode==='modal' ? 20 : 8"
        :value="$t(`Notifications.NotificationType.${value.messageType}`)"/>
    </div>
  </div>
</template>
<script>
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'
import NotificationCardTitle from 'components/common/blocks/notification/NotificationCardTitle.vue'
import NotificationCardAuthor from 'components/common/blocks/notification/NotificationCardAuthor.vue'

export default {
  name: 'notificationCard',
  props: {
    value: {
      type: Object,
      require: true
    },
    index: {
      type: Number
    },
    mode: {
      type: String,
      default: 'card'
    }
  },
  methods: {
    changeViewed(item) {
      if (!this.value.viewed) {
        this.$emit('changeViewed', item)
      }
    },
  },
  components: {
    TooltipedText,
    NotificationCardTitle,
    NotificationCardAuthor
  }
}
</script>
<style scoped lang="scss">
.notification-type {
  margin: auto 0 auto 5px;
  border-radius: 50px;
  color: var(--v-secondary__green_not_active-base);
  padding: 0 5px;
  text-align: left;
  border: 1px solid var(--v-secondary__green_not_active-base);
}
.notification-row {
  margin-top: 5px;
  cursor: pointer;
  margin-bottom: 10px;
  border-bottom: 1px solid var(--color-main-green);
}
.notification-card-org {
  width: calc(100% - 95px);
  &.modal {
    width: initial;
  }
}
.notification-card-type {
  width: 95px;
  &.modal {
    width: initial;
  }
}
</style>
